<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte/internal'
    import { faAngleLeft, faEdit, faPlusCircle, faSave, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
    // ##############################################################################################################
    import Content from '../../_common/content.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import ZContainer from '../../_common/z/z-container.svelte'
    import { GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import { ReferralsRepository } from '../../../modules/eventsApi/referrals/referrals.repository'
    import { ReferralsService } from '../../../modules/eventsApi/referrals/referrals.service'
    import { Referral } from '../../../modules/eventsApi/referrals/referral'
    import type { ReferralCreateDto } from '../../../modules/eventsApi/referrals/referral-create.dto'
    import type { ReferralUpdateDto } from '../../../modules/eventsApi/referrals/referral-update.dto'

    const entityId = 'referralId'

    const rep = new ReferralsRepository()
    const service = new ReferralsService(rep)
    const dispatch = createEventDispatcher()

    function sendClose() {
        dispatch('close')
    }

    export let referralId = null
    export let form: boolean = false

    let show = false
    let step = 1
    let entities: Referral[] = []
    let entity: Referral = new Referral()

    async function editEntity(id: string) {
        try {
            show = true
            entity = new Referral()
            entity = await service.getOne(id)
            step = 2
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function newEntity() {
        entity = new Referral()
        step = 2
    }

    async function createEntity() {
        try {
            show = true
            const dto: ReferralCreateDto = {
                label: entity.label,
            }
            entity = await service.create(dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            show = true
            const dto: ReferralUpdateDto = {
                label: entity.label,
            }
            await service.update(entity[entityId], dto)
            if (form) {
                sendClose()
                return
            }
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (entity[entityId]) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    async function loadEntities() {
        try {
            show = true
            step = 1
            entities = await service.getAll()
            loadGrid()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Origens do cliente'
        grid.subtitle = ''
        grid.cols.push(new GridCol({ content: 'Origem' }))
        grid.cols.push(new GridCol({ content: 'Data de cadastro', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: item.label })
            line.slots.push({ content: item.createdAt })
            line.slots.push({
                content: [
                    new GridButton({
                        label: 'Editar',
                        icon: faEdit,
                        callback: () => {
                            editEntity(item.referralId)
                        },
                    }),
                ],
            })
            grid.lines.push(line)
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await service.remove(entity[entityId])
            await loadEntities()
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function showEntities() {
        step = 1
    }

    onMount(async () => {
        await loadEntities()
        if (form) {
            if (referralId) {
                await editEntity(referralId)
            } else {
                newEntity()
            }
        }
    })
</script>

{#if step === 1}
    <Content footer={true}>
        <Zact>
            <div class="spacer" />
            {#if window.store.token.permissions.tools.referrals.write}
                <Zbutton color="primary" icon={faPlusCircle} label="Nova origem" mobileHideLabel={true} on:click={newEntity} />
            {/if}
        </Zact>
        <Zgrid class="h-space" {grid} />
        <LoadSpinner {show} />
    </Content>
{/if}
{#if step === 2}
    <Content>
        <Zact>
            {#if !form}
                <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={showEntities} />
            {/if}
            <div class="spacer" />
            {#if window.store.token.permissions.tools.referrals.write}
                {#if !!entity[entityId]}
                    <Zbutton color="red" icon={faTrashAlt} label="Excluir" disabled={show} on:click={removeEntity} />
                {/if}
                <Zbutton color="primary" icon={faSave} label="Salvar" loading={show} disabled={show} on:click={saveEntity} />
            {/if}
        </Zact>
        <div class="p-3">
            <Zframe title="Origem">
                <ZContainer>
                    <Zinput size={6} sizeM={12} label="Origem" bind:value={entity.label} />
                </ZContainer>
            </Zframe>
        </div>
        <LoadSpinner {show} />
    </Content>
{/if}
